import { Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { brandAssets, navigation } from "../data/siteData";

export default function Header({ onAccessRequest }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const handleScroll = useCallback(() => setScrolled(window.scrollY > 30), [setScrolled]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  useEffect(() => setOpen(false), [location.pathname, setOpen]);

  return (
    <header className={`site-header ${scrolled ? "site-header--solid" : ""}`} data-testid="site-header">
      <Link className="wordmark" to="/" data-testid="header-home-link" aria-label="GAMEDAY Holdings home">
        <img className="wordmark-logo" src={brandAssets.holdingsLogo} alt="GAMEDAY Holdings LLC logo" width="1024" height="1024" data-testid="header-holdings-logo" />
        <span>GAMEDAY <small>HOLDINGS LLC</small></span>
      </Link>
      <nav className="desktop-nav" aria-label="Main navigation" data-testid="desktop-navigation">
        {navigation.map(([label, path]) => <Link key={path} to={path} data-testid={`nav-${label.toLowerCase().replaceAll(" ", "-")}`}>{label}</Link>)}
      </nav>
      <div className="header-actions">
        <button className="button button--ghost" data-testid="header-investor-access-button" onClick={onAccessRequest}>Investor Access</button>
        <Link className="button button--ghost" to="/investor-portal" data-testid="header-investor-login-link">Investor Login</Link>
        <Link className="button button--red" to="/contact" data-testid="header-schedule-briefing-link">Schedule Briefing</Link>
        <button className="menu-button" aria-label="Open navigation" data-testid="mobile-navigation-toggle" onClick={() => setOpen(!open)}>{open ? <X /> : <Menu />}</button>
      </div>
      {open && <nav className="mobile-nav" aria-label="Mobile navigation" data-testid="mobile-navigation">
        {navigation.map(([label, path]) => <Link key={path} to={path} data-testid={`mobile-nav-${label.toLowerCase().replaceAll(" ", "-")}`}>{label}</Link>)}
        <button className="button button--red" data-testid="mobile-investor-access-button" onClick={onAccessRequest}>Request Investor Access</button>
        <Link className="button button--outline" to="/investor-portal" data-testid="mobile-investor-login-link">Investor Portal Login</Link>
      </nav>}
    </header>
  );
}